<template>
  <div>
    <dianka  :caozuo_flag_props="3" > </dianka> 
    <!-- mac_manage_flag 用于下级页面接收的参数 -->
  </div>
</template>
<script>
import dianka from '../../tongyong/dianka.vue';
 
export default {

  components: {
    dianka: dianka 
  },

  data() {
    return {
      // 获取用户列表参数
      
    };
  },
  props: [],
 
  watch: {
 
  },
  created() {
 
  },
  mounted() {
 
  }
}
</script>
